import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=c7cabe86&scoped=true"
import script from "./classInfo.vue?vue&type=script&lang=js"
export * from "./classInfo.vue?vue&type=script&lang=js"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=c7cabe86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cabe86",
  null
  
)

export default component.exports